import React from 'react';
import PropTypes from 'prop-types';

import {currentResource, labels} from '../../../../../util/utils';

import selectRelatableComponentItems from '../../../../../reducers/Reconciliations/selectors/selectRelatableComponentItems';

import columns from './columns';

import CustomTable from '../../../../CoreWrappers/CustomTable';

const ComponentRiskTable = ({
	id,
	primaryRiskId = null,
	value = [],
	isLoading = false,
	onChange = null,
	errorMessage = null
}) => {
	const mapRisk = (risk) => ({
		id: risk.riskId,
		...risk,
		disabled: risk.relatedComponentRisks?.some((rr) => rr.primaryRiskId !== primaryRiskId),
		isSelected: value.includes(risk.riskId),
		isLoading: isLoading?.includes(risk.riskId)
	});

	const componentRisks = selectRelatableComponentItems('risk');

	const handleChange = (id) => {
		let newValues = [...value];
		if (value.includes(id)) newValues = newValues.filter((item) => item !== id);
		else newValues = [...newValues, id];
		onChange && onChange(newValues, id);
	};

	const props = {
		id,
		data: componentRisks.map(mapRisk),
		columns: columns(currentResource.regionComponentRiskTableLabels, handleChange),
		labels: {
			emptyMessage: labels.noDataFound,
			show: labels.show,
			first: labels.first
		},
		pagination: false,
		defaultColumnSort: 'componentTeamRiskName'
	};

	if (errorMessage) props.errorMessage = errorMessage;

	return (
		<div className="full">
			<CustomTable {...props} />
		</div>
	);
};

ComponentRiskTable.propTypes = {};

export default ComponentRiskTable;
